import { toCatalogItemPayload } from '@/utils/eightByEightCatalog';

export const initFromService = (catalogue, serviceLicences) => {
    const licenceMap = {};
    (serviceLicences || []).forEach((licence) => {
        const itemID = licence.catalogItemID ?? licence.itemID;
        if (!itemID) return;
        licenceMap[itemID] = licence;
    });
    return catalogue.map((item) => {
        const licence = licenceMap[item.id];
        return {
            itemID: item.id,
            status: licence ? (licence.status ?? 'Enabled') : 'Disabled',
            volume: licence?.allowedQuantity ?? licence?.volume ?? 0,
        };
    });
};

export const buildActiveMap = (serviceLicences) => {
    const map = {};
    (serviceLicences || []).forEach((licence) => {
        const itemID = licence.catalogItemID ?? licence.itemID;
        if (!itemID) return;
        map[itemID] = licence.usedQuantity ?? licence.active ?? 0;
    });
    return map;
};

export const buildEightByEightServiceCatalogItems = ({
    serviceId,
    entitlements,
    serviceCatalogItems = [],
    catalogue = [],
}) => {
    const catalogItemMap = {};
    serviceCatalogItems.forEach((ci) => {
        if (ci.catalogItemID) {
            catalogItemMap[ci.catalogItemID] = ci.catalogItem;
        }
    });
    const catalogueMap = {};
    catalogue.forEach((c) => {
        catalogueMap[c.id] = c;
    });

    return (entitlements || []).map((e) => {
        const isEnabled = e.status === 'Enabled';
        const allowedQuantity = isEnabled ? (e.volume ?? 0) : 0;
        return {
            serviceID: serviceId,
            catalogItemID: e.itemID,
            allowedQuantity,
            catalogItem: toCatalogItemPayload(
                catalogItemMap[e.itemID] ??
                    catalogueMap[e.itemID] ?? { id: e.itemID },
            ),
        };
    });
};
